<div class="contactanos-section" *ngIf="listo">
    <div class="formulario-container">
        <p class="text-center mb-4 from-title">¡Contáctanos!</p>
        <p class="texto-from" style="text-align: center;">Un gerente inmobiliario te podrá acompañar en todos los
            trámites para adquirir una propiedad.</p>

        <form autocomplete="off" (ngSubmit)="guardarContactanos()" [formGroup]="formContactanos">
            <div class="row justify-content-center">
                <!-- Información -->
                <div class="col-auto">
                    <div class="custom-select-wrapper" [class.open]="openedSelect === 'informacion'">
                        <div class="custom-select-display" (click)="toggleSelect('informacion')">
                            <div class="custom-select-text">
                                <label class="custom-select-label" [class.float]="!!selectedInformacionText">
                                    Busco información de*
                                </label>
                                <span class="selected-value" *ngIf="selectedInformacionText">
                                    {{ selectedInformacionText }}
                                </span>
                            </div>
                            <img src="Inmuebles/assets/iconos/vector.svg" class="arrow"
                                [style.transform]="'rotate(' + informacionRotation + 'deg)'"
                                [style.transition]="'transform 0.3s ease'">
                        </div>
                        <ul class="custom-select-options" *ngIf="openedSelect === 'informacion'">
                            <li (click)="selectInformacion('Proceso de venta', 'Proceso de venta')">Proceso de venta
                            </li>
                            <li (click)="selectInformacion('Otro', 'Otro')">Otro</li>
                        </ul>
                    </div>
                </div>

                <!-- Estado -->
                <div class="col-auto">
                    <div class="custom-select-wrapper" [class.open]="openedSelect === 'estado'">
                        <div class="custom-select-display" (click)="toggleSelect('estado')">
                            <div class="custom-select-text">
                                <label class="custom-select-label" [class.float]="!!selectedEstadoText">
                                    Estado de interés de tu compra*
                                </label>
                                <span class="selected-value" *ngIf="selectedEstadoText">
                                    {{ selectedEstadoText }}
                                </span>
                            </div>
                            <img src="Inmuebles/assets/iconos/vector.svg" class="arrow"
                                [style.transform]="'rotate(' + estadoRotation + 'deg)'"
                                [style.transition]="'transform 0.3s ease'">
                        </div>
                        <ul class="custom-select-options estados-scroll" *ngIf="openedSelect === 'estado'"
                            style="max-height: 500px; overflow-y: auto;">
                            <li *ngFor="let estado of estados" (click)="selectEstado(estado)">
                                {{ estado.nombre }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Nombre y Apellido paterno-->
            <div class="row justify-content-center">
                <div class="col-auto">
                    <div class="floating-group" [class.error]="formContactanos.get('nombre')?.touched && formContactanos.get('nombre')?.errors && formContactanos.get('nombre')?.value">
                        <input type="text" formControlName="nombre" class="custom-wrapper" maxlength="50" placeholder="" (keypress)="soloLetras($event)" required>
                        <label class="floating-label" [attr.readonly]="isReadonly ? true : null"
                            (focus)="disableReadonly($event)">Nombre(s)*</label>
                        <div *ngIf="formContactanos.get('nombre')?.touched && formContactanos.get('nombre')?.errors">
                            <label class="helper-error" *ngIf="formContactanos.get('nombre')?.errors?.['longitud']">
                                Ingresa un nombre con más de 2 caracteres.
                            </label>
                            <label class="helper-error" *ngIf="formContactanos.get('nombre')?.errors?.['repetidos']">
                                No repitas caracteres seguidos.
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-auto">
                    <div class="floating-group" [class.error]="formContactanos.get('apellidoPaterno')?.touched && formContactanos.get('apellidoPaterno')?.errors && formContactanos.get('apellidoPaterno')?.value">
                        <input type="text" formControlName="apellidoPaterno" maxlength="50" class="custom-wrapper" placeholder=""
                            (keypress)="soloLetras($event)" required>
                        <label class="floating-label" [attr.readonly]="isReadonly ? true : null"
                            (focus)="disableReadonly($event)">Apellido 1*</label>
                        <div *ngIf="formContactanos.get('apellidoPaterno')?.touched && formContactanos.get('apellidoPaterno')?.errors">
                            <label class="helper-error" *ngIf="formContactanos.get('apellidoPaterno')?.errors?.['longitud']">
                                Ingresa un apellido con más de 2 caracteres.
                            </label>
                            <label class="helper-error" *ngIf="formContactanos.get('apellidoPaterno')?.errors?.['repetidos']">
                                No repitas caracteres seguidos.
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Apellido materno y correo -->
            <div class="row justify-content-center">
                <div class="col-auto">
                    <div class="floating-group" [class.error]="formContactanos.get('apellidoMaterno')?.touched && formContactanos.get('apellidoMaterno')?.errors && formContactanos.get('apellidoMaterno')?.value">
                        <input type="text" formControlName="apellidoMaterno" class="custom-wrapper" maxlength="50" placeholder="" (keypress)="soloLetras($event)">
                        <label class="floating-label" [attr.readonly]="isReadonly ? true : null"
                            (focus)="disableReadonly($event)">Apellido 2 (Opcional)</label>
                        <div *ngIf="formContactanos.get('apellidoMaterno')?.touched && formContactanos.get('apellidoMaterno')?.errors">
                            <label class="helper-error" *ngIf="formContactanos.get('apellidoMaterno')?.errors?.['longitud']">
                                Ingresa un apellido con más de 2 caracteres.
                            </label>
                            <label class="helper-error" *ngIf="formContactanos.get('apellidoMaterno')?.errors?.['repetidos']">
                                No repitas caracteres seguidos.
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-auto">
                    <div class="floating-group">
                        <input type="email" formControlName="correo" name="correo" class=".custom-wrapper"
                            placeholder="" autocomplete="off" required>
                        <label class="floating-label" [attr.readonly]="isReadonly ? true : null"
                            (focus)="disableReadonly($event)">Correo electrónico*</label>
                    </div>
                </div>
            </div>

            <!-- Teléfonos -->
            <div class="row justify-content-center">
                <!-- Teléfono móvil -->
                <div class="col-auto">
                    <div class="floating-group" [class.error]="formContactanos.get('telcel')?.touched && formContactanos.get('telcel')?.errors && formContactanos.get('telcel')?.value">
                        <input type="tel" formControlName="telcel" class="custom-wrapper" placeholder=""
                            autocomplete="off" inputmode="numeric" maxlength="10" (keypress)="soloNumeros($event)">
                        <label class="floating-label" [attr.readonly]="isReadonly ? true : null"
                            (focus)="disableReadonly($event)">
                            Teléfono móvil*
                        </label>
                        <div *ngIf="formContactanos.get('telcel')?.touched && formContactanos.get('telcel')?.errors">
                            <label class="helper-error" *ngIf="formContactanos.get('telcel')?.errors?.['repetidos5']">
                                No repitas el mismo dígito más de 5 veces seguidas.
                            </label>
                            <label class="helper-error" *ngIf="formContactanos.get('telcel')?.errors?.['telefonoInvalido']">
                                Ingresa el teléfono móvil a 10 dígitos.
                            </label>
                        </div>
                    </div>
                </div>
                <!-- Teléfono fijo opcional -->
                <div class="col-auto">
                    <div class="floating-group" [class.error]="formContactanos.get('telfijo')?.touched && formContactanos.get('telfijo')?.errors && formContactanos.get('telfijo')?.value">
                        <input type="tel" formControlName="telfijo" class="custom-wrapper" placeholder=""
                            autocomplete="off" inputmode="numeric" maxlength="10" (keypress)="soloNumeros($event)">
                        <label class="floating-label" [attr.readonly]="isReadonly ? true : null"
                            (focus)="disableReadonly($event)">
                            Teléfono fijo (Opcional)
                        </label>
                        <div *ngIf="formContactanos.get('telfijo')?.touched && formContactanos.get('telfijo')?.errors">
                            <label class="helper-error" *ngIf="formContactanos.get('telfijo')?.errors?.['repetidos5']">
                                No repitas el mismo dígito más de 5 veces seguidas.
                            </label>
                            <label class="helper-error" *ngIf="formContactanos.get('telfijo')?.errors?.['telefonoInvalido']">
                                Ingresa el teléfono móvil a 10 dígitos.
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Mensaje -->
            <div class="row mb-3 justify-content-center">
                <div class="col-12">
                    <div class="floating-textarea">
                        <textarea id="mensaje" formControlName="mensaje" class="form-control w-100 custom-input"
                            placeholder="" autocomplete="off" maxlength="100"></textarea>
                        <label class="floating-label-textarea" [attr.readonly]="isReadonly ? true : null"
                            (focus)="disableReadonly($event)">Escribe un mensaje</label>
                    </div>
                    <div class="text-end small text-muted text-campo mt-4">
                        {{ formContactanos.get('mensaje')?.value?.length || 0 }}/100
                    </div>
                </div>
                <div class="row mb-4 justify-content-center">
                    <div class="col-12">
                        <p class="text-campo">Los campos marcados con (<span>*</span>) son obligatorios.</p>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center align-items-center mb-2">
                <div class="col-auto text-center">
                    <label class="mb-2 text-camp-title">Recibir información a través
                        de:<span>*</span></label><br>
                    <div class="radios-contacto">
                        <div class="form-check">
                            <input type="radio" class="custom-radio" formControlName="contacto" value="correo">
                            <label class="form-check-label text-campo">Correo electrónico</label>
                        </div>
                        <div class="form-check">
                            <input type="radio" class="custom-radio" formControlName="contacto" value="telefono">
                            <label class="form-check-label text-campo">Teléfono</label>
                        </div>
                        <div class="form-check">
                            <input type="radio" class="custom-radio" formControlName="contacto" value="ambos">
                            <label class="form-check-label text-campo">Ambos</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text-center mt-4" style="display: flex; justify-content: center; gap: 20px;">
                <button type="button" (click)="limpiarForm()" class="btn btn-cancelar me-2">Cancelar</button>
                <button type="submit" class="btn btn-enviar me-2"
                    [disabled]="!formContactanos.valid || !formContactanos.dirty || enviado">Enviar</button>
            </div>
        </form>
    </div>
</div><br>